export default class tController {
  constructor({ game, activate }) {
    this.game = game;

    this.bindedHandleWindowResize = this.handleWindowResize.bind(this);
    this.bindedWindowBlur = this.handleWindowBlur.bind(this);
    this.bindedWindowFocus = this.handleWindowFocus.bind(this);
    this.bindedVisibilityChange = this.handleVisibilityChange.bind(this);

    if (activate) {
      this.activate();
    }
  }

  activate() {
    window.addEventListener('resize', this.bindedHandleWindowResize);
    window.addEventListener('blur', this.bindedWindowBlur);
    window.addEventListener('focus', this.bindedWindowFocus);
    window.addEventListener('visibilitychange', this.bindedVisibilityChange);
  }

  deactivate() {
    window.removeEventListener('resize', this.bindedHandleWindowResize);
    window.removeEventListener('blur', this.bindedWindowBlur);
    window.removeEventListener('focus', this.bindedWindowFocus);
    window.removeEventListener('visibilitychange', this.bindedVisibilityChange);
  }

  handleWindowBlur() {}

  handleWindowFocus() {}

  handleVisibilityChange() {}

  handleWindowResize() {
    this.game.aspectController.updateGameSize();
  }
}
